<template>
  <div class="feedback">
    <router-view></router-view>
    <ContentView  >
      <template slot="operateLeft">
        <el-input class="enter-input" v-model="searchVal"  size="small" placeholder="请输入内容" @keyup.enter.native="search"></el-input>
        <!-- <el-button style="margin-left: 15px;" size="small" @click="addNotice">新建公告</el-button> -->
      </template>
      <template slot="operateRight"></template>
      <el-table class="feedbackTable" slot="contentBox" :data="tableData" :cell-class-name="'el-tooltip'" style="width: 100%">
        <!-- <el-table-column prop="title" width="160" label="标题"></el-table-column> -->
        <el-table-column type="expand">
            <template slot-scope="props">
                <el-form label-position="left"  class="demo-table-expand">
                    <el-form-item label="内容">
                        <span>{{props.row.content}}</span>
                    </el-form-item>
                    <el-form-item label="提交时间">
                        <span>{{props.row.dateTime}}</span>
                    </el-form-item>
                    <el-form-item label="状态">
                        <span>{{dataStatus[props.row.status]}}</span>
                    </el-form-item>
                    <el-form-item label="反馈人">
                        <span>{{props.row.userName}}</span>
                    </el-form-item>
                    <el-form-item label="处理意见">
                        <span>{{props.row.doContent}}</span>
                    </el-form-item>
                </el-form>
            </template>
        </el-table-column>
        <el-table-column prop="content" label="内容"  ></el-table-column>
        <el-table-column prop="dateTime" label="提交时间" width="180"></el-table-column>
        
        <el-table-column prop="status" label="状态" width="100">
            <template slot-scope="scope">
                 <el-tag  :type="tagType[scope.row.status]">{{dataStatus[scope.row.status]}}</el-tag>
            </template>
        </el-table-column>
        <el-table-column prop="userName" label="反馈人" width="140"></el-table-column>
        
        <el-table-column  prop="doContent" label="处理意见" width="140"></el-table-column>

        <el-table-column prop="id" label="操作" width="100" align="center">
            <template slot-scope="scope">
                <el-button v-if="scope.row.status=='0'" type="primary" size="small" @click="optData(scope.row)">处理</el-button>
                <!-- <el-button @click="opt(scope.row)"></el-button> -->
            </template>
        </el-table-column>
      </el-table>
    </ContentView>
    <el-dialog title="反馈处理" width="500px" :visible.sync="dialogFormVisible">
        <el-form :model="form">
            <el-form-item label="处理意见" >
                <el-input  type="textarea" :rows="4" v-model="form.content" autocomplete="off"></el-input>
            </el-form-item>
            
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible = false">取 消</el-button>
            <el-button style="color:#fff" type="primary" @click="onSave">确 定</el-button>
        </div>
    </el-dialog>
  </div>
</template>

<script>
import ContentView from "@/components/ContentView";
import apiPub from '@/api/public'
import { mapGetters } from "vuex";
export default {
  name: "feedback",
  data() {
    return {
      tableData: [],
      searchVal:"",
      options:[],
      dataStatus:{
          "0":"未处理",
          "1":"已处理"
      },
      tagType:{
        "0":"danger",
        "1":"success"
      },
      dialogFormVisible:false,
      form:{
           content:""
      },
      itemData:{},
      OrdFild:"DateTime",
      OrdSort:"desc",
      input:"",
      win: false,
      value: "",
      timesRun: 0,
      pageNum:15,
      page:1,
      total:0,
      isDetail:false
    };
  },
  components: {
    ContentView
  },
  computed: {
    ...mapGetters(["currentUser"]),
  },
  created() {
    this.onSearch();
  },
  methods: {
    
    //---------------查询区域--------begin----------
     onSearch(){
      this.page = 1;
      this.total = 0;
      this.getlist()
    },
    addNotice(){
      this.$router.push({
        path: "/notice/noticeForm",
        query: { }
      });
    },
    
    //---------------业务区域--------end-----------
    optData(data){
        this.dialogFormVisible=true;
        this.itemData=data;
        this.form={
           content:""
      };
    },
    onSave(){
      var that=this;
      var obj = {
        "url": apiPub.UpdateFeedback,
        "data":{
            "id":this.itemData.id, 
            "UserID":this.currentUser.id,
            "DoContent":this.form.content
        }
      };
      $http.request(obj,true,function(res) {
        // console.log(res)
        that.dialogFormVisible=false;
        that.onSearch()
        // that.tableData=res.data;
      })
    },
    
    //---------------表格操作--------begin-----------
    getlist(){
      var that=this;
      var SearchText=this.searchVal||""
      var obj = {
        "url": apiPub.UserFeedback,
        "data":{
          SearchText:SearchText,
          OrdFild:this.OrdFild,
          OrdSort:this.OrdSort,
          pageNum: that.page - 1,
          pageSize: that.pageNum,
        }
      };
      $http.request(obj,false,function(res) {
        // console.log(res)
        that.tableData=res.data;
      })
    },
    onDetail(e){
       this.$router.push({path: '/notice/noticeForm', query: {id:e.id}});
       return;
    }
    /// -----------------------分页--begin-----------------------------
    /// -----------------------分页--end-------------------------------
  }
};
</script>
<style>
.demo-table-expand {
    font-size: 0;
  }
  .demo-table-expand label {
    width: 90px;
    line-height: 30px;
    color: #99a9bf;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0 !important;
    
    /* width: 50%; */
  }
  .demo-table-expand .el-form-item .el-form-item__content{
    margin-bottom: 0 !important;
  }
  .demo-table-expand .el-form-item__content{
      line-height: 30px;
  }
</style>
<style scoped>


 .feedbackTable /deep/ .el-tooltip .cell{
     white-space: nowrap;
 }
.enterprise {
  /* padding: 20px; */
  background: #fff;
}
.org-logo {
  width: 40px;
  height: 40px;
}
.enter-input{
    width: 200px;

}
.enter-input+.enter-input{
    margin-left: 15px;
}
.el-form-item{
    margin-bottom: 10px;
}
</style>
